export default __webpack_public_path__ + "static/media/sanskar.e1f9c956.png";